<template>
  <BaseInput
      :label="label"
      v-model="formatted_val"
      :textAlign="textAlign"
      @keydown="keydown"
      @focusin="focusIn"
      @focusout="focusOut">
    <template v-slot:errors="">
      <slot name="errors"></slot>
    </template>
  </BaseInput>
</template>

<script>
import BaseInput from "@/components/UI/BaseInput/BaseInput";

export default {
  name: "PercentInput",
  components: {BaseInput},
  props: {
    label: {
      type: String,
      default: null
    },
    value: {
      required: true
    },
    decimals:{
      type: Number,
      default: 2
    },
    allow_negative: {
      type: Boolean,
      default: false
    },
    textAlign: {
      type: String,
      default: 'right'
    },
    decimals: {
      type: Number
    }
  },
  data() {
    return {
      focus: false,
    }
  },
  computed: {
    formatted_val: {
      get() {
        if (!this.focus && this.value !== null) {
          return `${this.getFormattedValue(this.value)} %`
        } else {
          return this.value;
        }
      },
      set(value) {
        let val = value;
        //handle comma and replace on dot
        if (val.indexOf(',') > -1) {
          val = val.replace(',', '.')
        }
        //check decimals length
        if (val.indexOf('.') > -1) {
          let parts = val.split('.')
          if (parts[1].length > this.decimals) {
            parts[1] = parts[1].substring(0, this.decimals)
          }
          val = parts.join(".");
        }

        let outside = +val;
        if (val === '' || val === '.' || val === ',') {
          this.$emit('input', null)
        } else {
          this.$emit('input', outside)
        }
      }
    }
  },
  methods: {
    getFormattedValue(x) {
      if (x.toString().indexOf('.') > -1) { //if number got decimals
        let parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        if (parts[1].length > this.decimals) { //check decimals length
          parts[1] = parts[1].substring(0, this.decimals)
        }
        return parts.join(".");
      } else { //just simple formatting w spaces
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      }

    },
    focusIn(e) {
      this.focus = true;
      this.$emit('focusin', e);
    },
    focusOut(e) {
      this.focus = false;
      this.$emit('focusout', e);
    },
    keydown(e) {
      //disable non numeric keys on input to imitate number input
      if (e.key.length === 1 && e.key !== '.' && e.key !== ',' && isNaN(e.key) && !e.ctrlKey && !e.metaKey ||
          ((e.key === ',' || e.key === '.') && (e.target.value.indexOf('.') > -1 || e.target.value.indexOf(',') > -1))
      ) {
        e.preventDefault();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.value-input {
  margin-bottom: 25px;
  font-family: 'Open Sans', sans-serif;
  position: relative;

  label {
    margin-bottom: 7px;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 14px;
    width: 100%;
    display: block;
    color: #757D85;
    text-align: left;
  }

  input {
    background: #FFFFFF;
    border: 1px solid #D3D7DC;
    box-sizing: border-box;
    border-radius: 2px;
    padding: 0 14px;
    height: 40px;
    font-size: 11px;
    color: #555;
    width: 100%;
    transition: all .2s;

    text-align: right;
    -moz-appearance: textfield;

    &.text_left {
      text-align: left;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }


    &::placeholder {
      color: #BDC3C9;
    }

    &:focus {
      border-color: #757D85;
      outline: none;
    }

    &:hover {
      border-color: lighten(#757D85, 5);
    }
  }

  .error {
    display: none;
  }

  &.--error {
    input {
      animation-name: shakeError;
      animation-fill-mode: forwards;
      animation-duration: 0.6s;
      animation-timing-function: ease-in-out;
      border-color: rgb(245, 127, 108);;
      outline: none;
    }

    .error {
      display: block;
      color: rgb(245, 127, 108);
      position: absolute;
      font-size: 0.7rem;
      position: absolute;
      bottom: 0;
      left: .5rem;
      transform: translateY(100%);
    }
  }
}

@keyframes shakeError {
  0% {
    transform: translateX(0px);
  }
  15% {
    transform: translateX(0.375rem);
  }
  30% {
    transform: translateX(-0.375rem);
  }
  45% {
    transform: translateX(0.375rem);
  }
  60% {
    transform: translateX(-0.375rem);
  }
  75% {
    transform: translateX(0.375rem);
  }
  90% {
    transform: translateX(-0.375rem);
  }
  100% {
    transform: translateX(0px);
  }
}
</style>
